import React,{useState, useEffect, useRef} from "react";
import  "../../css/style-new.css";
import  "../../css/developer1.css";
import "../../css/bootstrap.min.css";
import "../../css/font.css";
import { Link, useNavigate } from 'react-router-dom'
import axios from "axios";
import { associationurl, sportlist, schoolsurl, schoolsApiurl } from '../../apis/urls'
import { Multiselect } from "multiselect-react-dropdown";
import { decode } from "html-entities";
import { $ } from "react-jquery-plugin";
import { id } from "date-fns/locale";
import { message } from "antd";




const Addassociation = () => {

    let navigate = useNavigate();
    const RoutToList = () =>{
        navigate("/associations")
    }

    const [name,setName] = useState('');
    const [email,setEmail] = useState('');
    const [password,setPassword] = useState('');
    const [confirmPassword,setConfirmPassword] = useState('');
    const [sports_id, setSports_id] = useState(false);
    const [school_id, setSchool_id] = useState([]);
    const [status, setStatus] = useState(false);
    const firstRender = useRef(true);
    const [disable, setDisabled] = useState(true);
    const [emailvaliderror, setEmailValidErrors] = useState(null);

    useEffect(() => {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        SportsListing();
        SchoolListing();
    },[]
    );


    useEffect(() => {


            if (firstRender.current) {
              firstRender.current = false;
              return;
            }

        const formValidation = () => {
            const emailValidation = !/\S+@\S+\.\S+/.test(email);
              if (emailValidation) {
                setEmailValidErrors("Email address is invalid");
              } else {
                setEmailValidErrors(null);
              }
            };
           setDisabled(formValidation());

    },[email]
    );



    let schoolArray = []


    const handleSelect = (id) => {
        // setSchool_id(id)
            id?.map((item,index) => {
                schoolArray.push(item.id)
            }
            
            )
            setSchool_id(schoolArray)
            console.log(schoolArray)
            return schoolArray;
    };


    
    const handleRemove = (id) => {
        id?.map((item,index) => {
            schoolArray.push(item.id)
        }
        )

        setSchool_id(schoolArray)

    };

 
    const [nameError, setNameeError] = useState(false)
    const [emailError, setEmailError] = useState(false)
    const [sportsError, setSportsError] = useState(false)
    const [schoolError, setSchoolError] = useState(false)
    const [statusError, setStatusError] = useState(false)
    const [nameExist, setNameExist] = useState('')
    const [emailExist, setEmailExist] = useState('')

      

    const handleSubmit = () => {

        if(name === ''){
            setNameeError(true)
        }
        else{
            setNameeError(false) 
        }
        if(email === ''){
            setEmailError(true)
        }
        else{
            setEmailError(false) 
        }
        if(sports_id === "0" || sports_id === false){
            setSportsError(true)
        }
        else{
            setSportsError(false) 
        }
        if(school_id === []){
            setSchoolError(true)
        }
        else{
            setSchoolError(false) 
        }        
        if(status === "0" || status === false){
            setStatusError(true)
        }
        else{
            setStatusError(false) 
        }
        
        let error = 0;

            let token = "Bearer "+localStorage.getItem('token');
            console.log("data", schoolArray)

                const data = {
                    name :name,
                    email:email,
                    sports_id:sports_id,
                    school_id:school_id,
                    status :'NO'
                }        
                const instance = axios.create({
                    baseURL: associationurl,
                    timeout: 1000000,
                    headers: {'authorization': token}
                });

            instance.post('', data).then(res => {

                if(res.data.message === "Email already used in other role")
                {
                    message.error({content:'Email already used in other role. Please change your email', duration:5});
                    setEmail('');
                }else{
                    navigate("/associations")
                    console.log(res.data.message)
                }


            }).catch(error => {
                console.log("error",error.response.data.error[0].email )

                if(error.response.data.error[0].name === "Association name is already in use!"){
                    setNameExist("Name already in use")
                    }
                    else{setNameExist('')}

                if(error.response.data.error[0].email === "School email is already in use" || error.response.data.error[1].email === "School email is already in use"){
                setEmailExist("User already exist")
                }
                else{setEmailExist('')}
        });
    }


    const [sportsResult, setSportsResult] = useState([]);
    const SportsListing = () => {
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: sportlist+'?page='+0+'&size='+100,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setSportsResult(response.data.data.items);

            // console.log(response.data.data)
           
          }).catch((error) =>{
            
            console.log('error',error.message)
          });
    }


    const [schoolResult, setSchoolResult] = useState([]);
    const SchoolListing = () => {
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: schoolsApiurl,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setSchoolResult(decode(response.data.data));
            //console.log(decode(response.data.data))
           
          }).catch((error) =>{
            
            console.log('error',error.message)
          });
    }



   
    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Add New Association</h2>
                        </div>
                        <div className="page-rightside-action-column">

                        </div>
                    
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/associations">Association</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Add Association</li>
                        </ol>
                    </nav>


                    <form className="needs-validation" noValidate >
                        <div className="form-wrpr">
                            <div className="card formcard medium">
                                <div className="card-body">
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Association Name<span style={{color: "red"}}>*</span></label>
                                            <input type="text" 
                                            className="form-control justshow bg-dark" 
                                            placeholder="Enter Association Name"
                                            value={name}
                                            onChange={e => setName(e.target.value)} />
                                            {
                                                nameError
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Name </div>
                                                :null
                                            }
                                            {
                                                nameExist
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{nameExist}</div>
                                                :null
                                            }

                                        </div>

                                        <div className="col-md-6">
                                            <label >Contact Email<span style={{color: "red"}}>*</span></label>		
                                            <input type="email" 
                                            className="form-control justshow bg-dark" 
                                            placeholder="Enter Contact Email"
                                            value={email}
                                            onChange={e => setEmail(e.target.value)}  />
                                            {
                                                emailError
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Enter Email</div>
                                                : <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{emailvaliderror && <p>{emailvaliderror}</p>}</div>
                            			    }
                                            {
                                                emailExist
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{emailExist}</div>
                                                :null
                                            }

                                        </div>
                                    </div>
							    </div>
                                {/* <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Password<span style={{color: "red"}}>*</span></label>
                                            <input 
                                            type="password" 
                                            className="form-control justshow bg-dark" 
                                            placeholder="Enter Password" 
                                            value={password}
                                            onChange={e => setPassword(e.target.value)} />
                                        </div>
                                        <div className="col-md-6">
                                            <label >Confirm Password</label>		
                                            <input type="password" 
                                            className="form-control justshow bg-dark" 
                                            placeholder="Enter Confirm Password"
                                            value={confirmPassword}
                                            onChange={e => setConfirmPassword(e.target.value)}  />
                                        </div>
                                    </div>
							    </div> */}
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label >Sport<span style={{color: "red"}}>*</span></label>
                                            <select className="form-control bg-dark dark-theme showtext" onChange={e => {setSports_id(e.target.value)}} id="status-selector">
                                            <option value="0">Select Sport</option>
                                            {
                                                sportsResult?.map((item,index)=>(
                                                    item.status === 'ACTIVE'?
                                                    <option key={index} value={item.id}>{item.name}</option> :null   
                                                    
                                                )
                                                )
                                            }
                                            </select>    
                                            {
                                                sportsError
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Select The Sports </div>
                                                :null
                                            }                                
                                        </div>
                                        <div className="col-md-6">
                                            <label > GIAA Member Schools</label>		
                                                <Multiselect
                                                    placeholder={school_id?.length===0?"You can type and select multiple schools":"Select"}
                                                    options={decode(schoolResult)}
                                                    value={decode(schoolArray)}
                                                    onSelect={handleSelect}
                                                    onRemove={handleRemove} 
                                                    displayValue="name" 
                                                    />
                                            {
                                                schoolError
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Select The School </div>
                                                :null
                                            } 
                                        </div>
                                    </div>
							    </div>
                                {/* <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label >Status</label>	
                                            <select  value={status} onChange={e => {setStatus(e.target.value)}} type="text" class="form-control bg-dark" id="state">
                                                <option value="0">Select Status</option>
                                                <option>ACTIVE</option>
                                                <option>INACTIVE</option>
                                                <option>DELETED</option>
                                                {
                                                statusError
                                                ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Select The Sports </div>
                                                :null
                                                } 
                                        </select>
                                        </div>
                                    </div>
                                </div>
                             */}
                                <div className="form-group text-right">
							        <button className="btn btn-danger btn-gisa" onClick={RoutToList} type="submit">Cancel</button>
								    <button className="btn btn-primary btn-gisa" onClick={handleSubmit} type="button">Create </button>
							    </div>



                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </aside>
        </div>
    )
}

export default Addassociation;